export { default } from './Ingredients';
